import { PAGE_HOME, PAGE_NAME, AUTHORITY } from '@/enums'
import { RouteRecordRaw } from 'vue-router'
import { getRouteRaw } from './helper'

export const RootRoute = getRouteRaw(PAGE_NAME.ROOT, '/', {
  component: () => import('@/pages/Home/index.vue'),
  redirect: { name: PAGE_HOME },
  children: [
    getRouteRaw(PAGE_NAME.INSIGHT_LIST, 'insight-list/:videoMd5?', {
      component: () => import('@/pages/Home/InsightList/index.vue'),
      authority: (a) => a >= AUTHORITY.ok,
    }),
    getRouteRaw(PAGE_NAME.Brief, 'brief', {
      component: () => import('@/pages/Home/Brief/index.vue'),
      authority: (a) => a >= AUTHORITY.ok,
    }),
    getRouteRaw(PAGE_NAME.Project, 'project', {
      component: () => import('@/pages/Home/Project/index.vue'),
      authority: (a) => a >= AUTHORITY.ok,
    }),
    getRouteRaw(PAGE_NAME.ItemCenter, 'item-center', {
      component: () => import('@/pages/Home/ItemCenter/index.vue'),
      authority: (a) => a >= AUTHORITY.ok,
    }),
  ],
})

export const WhiteRoutes: RouteRecordRaw[] = [
  getRouteRaw(PAGE_NAME.LOGIN, '/login', {
    component: () => import('@/pages/Login/index.vue'),
    meta: { title: '登录' },
  }),

  getRouteRaw(PAGE_NAME.PAGE_NOT_FOUND, '/:path(.*)*', {
    component: () => import('@/pages/404/index.vue'),
  }),
]

export const routes = [
  RootRoute,
  getRouteRaw(PAGE_NAME.NOT_SET, '/not-set', {
    component: () => import('@/pages/NotSet/index.vue'),
    authority: (a) => a === AUTHORITY.needFirstSet,
  }),
  getRouteRaw(PAGE_NAME.Tenant, '/tenant', {
    component: () => import('@/pages/Tenant/index.vue'),
    authority: (a) => a === AUTHORITY.needChooseTenant,
  }),
  getRouteRaw(PAGE_NAME.BriefDetail, '/brief-detail/:id', {
    component: () => import('@/pages/BriefDetail/index.vue'),
    authority: (a) => a >= AUTHORITY.ok,
  }),
  getRouteRaw(PAGE_NAME.VideoDetail, '/video-detail/:id', {
    component: () => import('@/pages/VideoDetail/index.vue'),
    authority: (a) => a >= AUTHORITY.ok,
  }),
  getRouteRaw(PAGE_NAME.ProjectDetail, '/project/:id', {
    component: () => import('@/pages/ProjectDetail/index.vue'),
    redirect: { name: PAGE_NAME.ProjectMaterial },
    children: [
      getRouteRaw(PAGE_NAME.ProjectMaterial, 'material', {
        component: () => import('@/pages/ProjectDetail/ProjectMaterial/index.vue'),
        authority: (a) => a >= AUTHORITY.ok,
      }),
    ],
  }),

  ...WhiteRoutes,
]
